import { MaterialityType } from '@upright/common/model/input/materiality-assessment/types';
import {
  GetWeightSetCsrdConstituentExportDataRequestPathParams,
  GetWeightSetCsrdConstituentExportDataResponse,
  GetWeightSetCsrdExportDataRequestPathParams,
  GetWeightSetCsrdExportDataResponse,
  GetWeightSetCsrdItemDataRequestPathParams,
  GetWeightSetCsrdItemDataResponse,
  GetWeightSetCsrdTopLevelResultsRequestPathParams,
  GetWeightSetCsrdTopLevelResultsResponse,
  GetWeightSetCsrdValenceLevelResultRequestPathParams,
  GetWeightSetCsrdValenceLevelResultResponse,
  GetWeightSetCsrdVariantResultsRequestPathParams,
  GetWeightSetCsrdVariantResultsResponse,
  TriggerWeightSetCsrdExportJobRequestPathParams,
  TriggerWeightSetCsrdExportJobResponse,
} from '@upright/common/model/output/materiality/csrd-weight-set-results/api-types';
import { GetCompanyMaterialityMatrixResponse } from '@upright/common/model/output/materiality/materiality-matrix/api-types';
import { fetchOrThrow } from '@upright/ui/api/common/fetchers/fetch-or-throw';

export async function fetchWeightSetCsrdTopLevelResults(
  params: GetWeightSetCsrdTopLevelResultsRequestPathParams,
): Promise<GetWeightSetCsrdTopLevelResultsResponse> {
  return await fetchOrThrow<GetWeightSetCsrdTopLevelResultsResponse>(
    `/materiality/weight-set/top-level/${params.weightSetResultId}`,
  );
}

export async function fetchWeightSetCsrdValenceLevelResult<T extends MaterialityType>(
  params: GetWeightSetCsrdValenceLevelResultRequestPathParams<T>,
): Promise<GetWeightSetCsrdValenceLevelResultResponse<T>> {
  return await fetchOrThrow<GetWeightSetCsrdValenceLevelResultResponse<T>>(
    `/materiality/weight-set/valence-level/${params.weightSetResultId}/${params.materialityType}/${params.matterId}/${params.valence}`,
  );
}

export async function fetchWeightSetCsrdVariantResults<T extends MaterialityType>(
  params: GetWeightSetCsrdVariantResultsRequestPathParams<T>,
): Promise<GetWeightSetCsrdVariantResultsResponse<T>> {
  return await fetchOrThrow<GetWeightSetCsrdVariantResultsResponse<T>>(
    `/materiality/weight-set/variant-results/${params.weightSetResultId}/${params.materialityType}/${params.matterId}/${params.valence}`,
  );
}

export async function fetchWeightSetCsrdItemData(
  params: GetWeightSetCsrdItemDataRequestPathParams,
): Promise<GetWeightSetCsrdItemDataResponse> {
  return await fetchOrThrow<GetWeightSetCsrdItemDataResponse>(
    `/materiality/weight-set/item-data/${params.weightSetResultId}`,
  );
}

export async function triggerWeightSetCsrdExportJob(params: TriggerWeightSetCsrdExportJobRequestPathParams) {
  return await fetchOrThrow<TriggerWeightSetCsrdExportJobResponse>(
    `/materiality/weight-set/export-data/${params.weightSetResultId}/trigger`,
    'POST',
  );
}

export async function fetchWeightSetCsrdExportData(params: GetWeightSetCsrdExportDataRequestPathParams) {
  return await fetchOrThrow<GetWeightSetCsrdExportDataResponse>(`/materiality/weight-set/export-data/${params.jobId}`);
}

export async function triggerWeightSetCsrdConstituentExportJob(params: TriggerWeightSetCsrdExportJobRequestPathParams) {
  return await fetchOrThrow<TriggerWeightSetCsrdExportJobResponse>(
    `/materiality/weight-set/export-data/${params.weightSetResultId}/constituents/trigger`,
    'POST',
  );
}

export async function fetchWeightSetCsrdConstituentExportData(
  params: GetWeightSetCsrdConstituentExportDataRequestPathParams,
) {
  return await fetchOrThrow<GetWeightSetCsrdConstituentExportDataResponse>(
    `/materiality/weight-set/export-data/constituents/${params.jobId}`,
  );
}

export async function fetchWeightSetMaterialityMatrixData(weightSetResultId: number) {
  const url = `/materiality/weight-set/matrix/${weightSetResultId}`;
  return await fetchOrThrow<GetCompanyMaterialityMatrixResponse>(url);
}
